import { IBarcode } from '@nocode/types';
import { get } from 'lodash';
import React, { useMemo } from 'react';
import Barcode from 'react-barcode';
import { TouchableOpacity } from 'react-native';
import { getActions, getItemListClick, getValueBinding } from '../../shared';
import createStyles from './style';
import normalizeCodabarValue, {
  toJsBarcodeFormat,
} from '../../BarCode/normalizeCodabarValue';

const BarCode: React.FC<IBarcode> = (props) => {
  const styles = createStyles(props);
  const { onPress } = props;
  const format = props.attributes?.format ?? 'CODE128';
  const autoWrap = props.attributes?.autoWrap ?? true;

  const barCodeValue = useMemo(() => {
    const isItemList = !!props?.record;

    const bindingValue = getValueBinding(
      isItemList ? props.initId : props.id,
      isItemList ? props?.record : props.data,
      props
    );
    const rawValue =
      format === 'Codabar'
        ? get(bindingValue, 'codabarValue')
        : get(bindingValue, 'value');
    if (rawValue === undefined || rawValue === null || rawValue === '') {
      return '';
    }
    const stringValue = String(rawValue);
    return format === 'Codabar'
      ? normalizeCodabarValue(stringValue, autoWrap)
      : stringValue;
  }, [props, format, autoWrap]);

  const handlePress = (id: string) => {
    onPress &&
      onPress(getActions(props, id), {
        itemListClick: getItemListClick(props.record),
      });
  };

  const barCodeHeight = props.height - 5;
  return barCodeValue ? (
    <TouchableOpacity
      style={styles.container}
      onPress={() => handlePress('onPress')}
    >
      <Barcode
        value={barCodeValue}
        format={toJsBarcodeFormat(format)}
        margin={0}
        marginBottom={10}
        height={barCodeHeight}
      />
    </TouchableOpacity>
  ) : null;
};

export default BarCode;
